// extracted by mini-css-extract-plugin
export var alignCenter = "_bj-d";
export var bannerShown = "_bj-6";
export var buttonContent = "_bj-0";
export var cardList = "_bj-1";
export var centerContent = "_bj-2";
export var chevron = "_bj-3";
export var closePanelButton = "_bj-k";
export var conversationContextContainer = "_bj-l";
export var conversationDetailContainer = "_bj-4";
export var detailWrapper = "_bj-7";
export var dropdownButton = "_bj-e";
export var dropdownTitle = "_bj-9";
export var fullHeight = "_bj-5";
export var hidden = "_bj-a";
export var icon = "_bj-b";
export var mergeSuggestionWrapper = "_bj-m";
export var panel = "_bj-i";
export var portalButtonsWrapper = "_bj-c";
export var right = "_bj-j";
export var tableSummaryContainer = "_bj-8";
export var tableSummaryHeader = "_bj-g";
export var threeDotsButton = "_bj-f";
export var wide = "_bj-h";